import React from "react";
import Header from "../../Layout/Header";
import Footer from "../../Layout/Footer";

const About = () => {
  return (
    <>
      <Header />
      {/* <div class="">
        <div class="">
          <div class="">
            <h1>About GAFHC</h1>
            <p>Cum doctus civibus efficiantur in imperdiet deterruisset.</p>
          </div>
          <div class="row justify-content-between">
            <div class="col-lg-6">
              <figure class="add_bottom_30">
                <img src="img/about_1.jpg" class="img-fluid" alt="" />
              </figure>
            </div>
             <div className="">
              <video autoPlay loop muted>
                <source src="img/video1.mp4" type="video/mp4" />
              </video>
            </div>
            <div class="col-lg-5">
              <p>
                The Global Alliance for Hypnosis Clinicians (GAFHC) was created
                by one of the world’s top medical hypnotherapists named{" "}
                <strong>Sharon Waxkirsh. </strong>.h. Sharon has been practicing
                medical hypnosis for over 17 years and saw the need for the
                creation of a global network of clinicians and well-trained
                hypnosis practitioners in order to take the field of
                hypnotherapy to the next level of medical application.
              </p>
              <p>
                Many hypnotherapists operate as individually-owned businesses
                with each practitioner having to create their individual
                networks from nothing. In addition, many patients who would like
                to utilize hypnoanalgesia in place of chemical anesthesia are
                incapable of successfully finding medical clinicians and
                hypnotherapists who specialize in this specific technique. With
                her vast experience, Sharon also realized that many
                hypnotherapists do not have the necessary hands-on, field
                training in order to successfully carry out hypnoanalgesia in
                patients undergoing surgery. This is why she has also worked
                with some of the top medical doctors, dentists, and
                hypnotherapists in order to develop a top-tier training protocol
                for those that want to practice medical hypnosis.
              </p>
              <p>
                <em>CEO Marc Schumaker</em>
              </p>
            </div>
          </div>
          {/* <!--/row--> */}
        {/* </div> */}
        {/* <!--/container--> */}
      {/* </div> */} 
      {/* <!--/bg_color_1--> */}
            <div className="container content col-md-8 mx-auto mb-5">
              <div class="text-center my-5">
              <h1>About GAFHC</h1>
              </div>
              <p className="fs-md-6">
                The Global Alliance for Hypnosis Clinicians (GAFHC) was created
                by one of the world’s top medical hypnotherapists named{" "}
                <strong>Sharon Waxkirsh. </strong>.h. Sharon has been practicing
                medical hypnosis for over 17 years and saw the need for the
                creation of a global network of clinicians and well-trained
                hypnosis practitioners in order to take the field of
                hypnotherapy to the next level of medical application.
              </p>
              <br/>
              <p>
              Many hypnotherapists operate as individually-owned businesses
                with each practitioner having to create their individual
                networks from nothing. In addition, many patients who would like
                to utilize hypnoanalgesia in place of chemical anesthesia are
                incapable of successfully finding medical clinicians and
                hypnotherapists who specialize in this specific technique. With
                her vast experience, Sharon also realized that many
                hypnotherapists do not have the necessary hands-on, field
                training in order to successfully carry out hypnoanalgesia in
                patients undergoing surgery. This is why she has also worked
                with some of the top medical doctors, dentists, and
                hypnotherapists in order to develop a top-tier training protocol
                for those that want to practice medical hypnosis.
              </p>
            </div>

            {/* <div className="video-overlay"></div> */}
            <div className="video-container">
              <video autoPlay loop muted>
                <source src="img/aboutvideo.mp4" type="video/mp4" />
              </video>
            </div>

      {/* <div class="bg_color_1">
        <div class="container margin_120_95">
          <div class="main_title">
            <h2>What user says about us hi</h2>
            <p>Cum doctus civibus efficiantur in imperdiet deterruisset.</p>
          </div>
          <div class="row">
            <div class="col-md-4">
              <div class="about-review">
                <div class="rating">
                  <i class="icon_star voted"></i>
                  <i class="icon_star voted"></i>
                  <i class="icon_star voted"></i>
                  <i class="icon_star voted"></i>
                  <i class="icon_star voted"></i> <strong>Excellent!</strong>
                </div>
                <p>
                  "Vel esse mucius omittantur ei. Nostrum fabellas similique ex
                  qui, dolor semper mentitum ut est, ea nec mutat vocent. Animal
                  commodo in quo, et nec zril dolor homero. Meis graece ad pro,
                  mea simul discere no."
                </p>
                <div class="user_review">
                  <figure>
                    <img src="img/avatar1.jpg" alt="" />
                  </figure>
                  <h4>
                    Dr. Joseph Luiss<span>Doctor</span>
                  </h4>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="about-review">
                <div class="rating">
                  <i class="icon_star voted"></i>
                  <i class="icon_star voted"></i>
                  <i class="icon_star voted"></i>
                  <i class="icon_star voted"></i>
                  <i class="icon_star voted"></i> <strong>Superb!</strong>
                </div>
                <p>
                  "Ad agam dignissim has, posse melius dissentiet eam eu. Vel
                  accusamus instructior ex, his ne omnes commodo efficiantur.
                  Duo quod inani maluisset te, ea per alia minimum officiis."
                </p>
                <div class="user_review">
                  <figure>
                    <img src="img/avatar2.jpg" alt="" />
                  </figure>
                  <h4>
                    Pablo Jemenez<span>User</span>
                  </h4>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="about-review">
                <div class="rating">
                  <i class="icon_star voted"></i>
                  <i class="icon_star voted"></i>
                  <i class="icon_star voted"></i>
                  <i class="icon_star voted"></i>
                  <i class="icon_star voted"></i> <strong>Very useful!</strong>
                </div>
                <p>
                  "Duo omnis iudicabit quaerendum ut. Ius quis adipiscing ut. Id
                  mea graeco fabulas. Pri iisque interpretaris at, per diam
                  suscipiantur in, ut ludus labore iriure pro."
                </p>
                <div class="user_review">
                  <figure>
                    <img src="img/avatar3.jpg" alt="" />
                  </figure>
                  <h4>
                    Marc Twain<span>User</span>
                  </h4>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-4">
              <div class="about-review">
                <div class="rating">
                  <i class="icon_star voted"></i>
                  <i class="icon_star voted"></i>
                  <i class="icon_star voted"></i>
                  <i class="icon_star voted"></i>
                  <i class="icon_star voted"></i> <strong>Satisfied!</strong>
                </div>
                <p>
                  "Elitr doming consetetur ut has, noluisse interesset te vis.
                  Nemore habemus mea at, has no probo mucius omittam. Scripta
                  numquam eruditi ad pri, quo docendi vivendum ea. "
                </p>
                <div class="user_review">
                  <figure>
                    <img src="img/avatar.jpg" alt="" />
                  </figure>
                  <h4>
                    Dr. Julia Roberts<span>Doctor</span>
                  </h4>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="about-review">
                <div class="rating">
                  <i class="icon_star voted"></i>
                  <i class="icon_star voted"></i>
                  <i class="icon_star voted"></i>
                  <i class="icon_star voted"></i>
                  <i class="icon_star voted"></i> <strong>Love it!</strong>
                </div>
                <p>
                  "Unum justo sea ne, no facer intellegat vituperatoribus duo,
                  vix an meliore expetendis. Ei pro liber regione consulatu. Est
                  soleat molestie ad. Oblique oportere pertinacia eum ne."
                </p>
                <div class="user_review">
                  <figure>
                    <img src="img/avatar.jpg" alt="" />
                  </figure>
                  <h4>
                    Dr.John Doe<span>Doctor</span>
                  </h4>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="about-review">
                <div class="rating">
                  <i class="icon_star voted"></i>
                  <i class="icon_star voted"></i>
                  <i class="icon_star voted"></i>
                  <i class="icon_star voted"></i>
                  <i class="icon_star voted"></i>{" "}
                  <strong>Great Support!</strong>
                </div>
                <p>
                  "Lorem ipsum dolor sit amet, ne quas inermis nec, graece
                  postea in nec. Eum propriae eligendi intellegam eu. Ius ei
                  tation intellegat."
                </p>
                <div class="user_review">
                  <figure>
                    <img src="img/avatar.jpg" alt="" />
                  </figure>
                  <h4>
                    Lucas<span>User</span>
                  </h4>
                </div>
              </div>
            </div>
          </div>

        </div>

      </div>


      <div class="container margin_120_95">
        <div class="main_title">
          <h2>Why Choose Findoctor</h2>
          <p>
            The field of hypnosis has experienced over 10,000 peer-reviewed
            research studies across the globe within the past 50 years. This
            surpasses the amount of research regarding both meditation and yoga
            which have both reached mainstream acceptance. However, the stigma
            surrounding hypnosis based on its usage for entertainment purposes
            has affected its adoption and utilization within clinical practice.
            This effect is detrimental to clinicians, hypnotherapists, and most
            importantly the patient population. GAFHC aims to overcome this by
            creating a global alliance of optimally-trained, certified
            practitioners of this field while developing premium-quality content
            highlighting the continuous rigorous ongoing research regarding the
            effects of hypnosis on pain, emotional distress, and neurological
            benefits.
          </p>
        </div>
        <div class="row">
          <div class="col-lg-4 col-md-6">
            <a class="box_feat_about" href="#2">
              <i class="pe-7s-id"></i>
              <h3>+ 5575 Doctors</h3>
              <p>
                Id mea congue dictas, nec et summo mazim impedit. Vim te audiam
                impetus interpretaris, cum no alii option, cu sit mazim libris.
              </p>
            </a>
          </div>
          <div class="col-lg-4 col-md-6">
            <a class="box_feat_about" href="#2">
              <i class="pe-7s-help2"></i>
              <h3>H24 Support</h3>
              <p>
                Id mea congue dictas, nec et summo mazim impedit. Vim te audiam
                impetus interpretaris, cum no alii option, cu sit mazim libris.{" "}
              </p>
            </a>
          </div>
          <div class="col-lg-4 col-md-6">
            <a class="box_feat_about" href="#2">
              <i class="pe-7s-date"></i>
              <h3>Instant Booking</h3>
              <p>
                Id mea congue dictas, nec et summo mazim impedit. Vim te audiam
                impetus interpretaris, cum no alii option, cu sit mazim libris.
              </p>
            </a>
          </div>
          <div class="col-lg-4 col-md-6">
            <a class="box_feat_about" href="#2">
              <i class="pe-7s-headphones"></i>
              <h3>Help Direct Line</h3>
              <p>
                Id mea congue dictas, nec et summo mazim impedit. Vim te audiam
                impetus interpretaris, cum no alii option, cu sit mazim libris.{" "}
              </p>
            </a>
          </div>
          <div class="col-lg-4 col-md-6">
            <a class="box_feat_about" href="#2">
              <i class="pe-7s-credit"></i>
              <h3>Secure Payments</h3>
              <p>
                Id mea congue dictas, nec et summo mazim impedit. Vim te audiam
                impetus interpretaris, cum no alii option, cu sit mazim libris.
              </p>
            </a>
          </div>
          <div class="col-lg-4 col-md-6">
            <a class="box_feat_about" href="#2">
              <i class="pe-7s-chat"></i>
              <h3>Support via Chat</h3>
              <p>
                Id mea congue dictas, nec et summo mazim impedit. Vim te audiam
                impetus interpretaris, cum no alii option, cu sit mazim libris.{" "}
              </p>
            </a>
          </div>
        </div>

      </div> */}
      <Footer />
    </>
  );
};

export default About;
